// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__182dn","itemTitle":"ClientEmergencyInfo_itemTitle__Rh6GZ","itemText":"ClientEmergencyInfo_itemText__2Q51d"};